import React from 'react'
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import PlantCareBody from '../Component/PlantCareBody';

const PlantCare = () => {
  return (
    <div>
        <Header/>
        <PlantCareBody/>
        <Footer/>
    </div>
  )
}

export default PlantCare;